import { StyledDivider } from "./styled";
import { IDividerProps } from "./types";

const Divider = ({ color, ...muiProps }: IDividerProps) => {
    return <StyledDivider customColor={color} {...muiProps} />;
};

export { Divider };

